import { createAction } from "redux-actions";
import { loadSystems as loadSystemsApi, deleteSystem as deleteSystemApi } from "../../services/home";

export enum ACTIONS {
	LOAD_SYSTEMS = "HOME/LOAD_SYSTEMS",
	DELETE_SYSTEM = "HOME/DELETE_SYSTEM",
	RESET_DELETED = "HOME/RESET_DELETED",
}

export const loadSystems = createAction(ACTIONS.LOAD_SYSTEMS, loadSystemsApi);
export const deleteSystem = createAction(ACTIONS.DELETE_SYSTEM, deleteSystemApi);
export const resetDeleted =  createAction(ACTIONS.RESET_DELETED);
